var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrewdriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 6.58258L8.96532 7.58572L10.0938 8.71424L2.94651 15.8616L1.44181 16.3631L0.0624997 19.1218L0.940242 19.9995L3.82426 18.7456L4.45121 17.2409L11.4732 10.0936L12.6017 11.2221L13.6048 10.0936C13.6048 10.0936 12.6017 9.3412 13.7302 8.21268C14.3572 7.58572 15.3603 8.33807 17.2412 6.45719L19.8744 3.82396C19.8744 3.82396 20.6268 2.57004 19.1221 1.06534C17.6174 -0.43936 16.3634 0.312991 16.3634 0.312991L13.7302 2.94622C11.9747 4.70171 12.6017 5.83023 12.1001 6.3318C10.9716 7.46033 10.0938 6.58258 10.0938 6.58258ZM13.981 7.08415L13.1033 6.20641L17.8681 1.44152L18.7459 2.31926L13.981 7.08415Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewdriver);
export default __webpack_public_path__ + "static/media/Screwdriver.396218a00302b81e5a821f945ddd6a5b.svg";
export { ForwardRef as ReactComponent };